export enum ProjectElementType {
	GITHUB_REPO = 'github_repo',
	DATABASE = 'database',
	CLOUD_INFRASTRUCTURE = 'cloud_infrastructure',
	CI_CD_PIPELINE = 'ci_cd_pipeline',
	DOMAIN = 'domain',
	MONITORING = 'monitoring',
	DOCUMENTATION = 'documentation',
	COMMUNICATION_CHANNEL = 'communication_channel',
	STORAGE = 'storage',
	API = 'api',
	OTHER = 'other',
}
